// app/javascript/modules/ferias/form_helpers.js
// Funções puras utilitárias para o formulário de férias.

/**
 * Faz parse de uma string de data no formato DD/MM/YYYY ou YYYY-MM-DD.
 * Retorna um objeto Date local ou null se inválido.
 */
export function parseBRDate(str) {
  if (!str) return null
  const br = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
  if (br) return new Date(+br[3], +br[2] - 1, +br[1])
  const iso = str.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (iso) return new Date(+iso[1], +iso[2] - 1, +iso[3])
  return null
}

/**
 * Calcula a quantidade de dias entre duas datas (inclusive).
 * Retorna -1 se as datas forem inválidas ou término < início.
 * Retorna 0 se alguma string estiver vazia.
 */
export function calcDias(ini, fim) {
  if (!ini || !fim) return 0
  const d1 = parseBRDate(ini)
  const d2 = parseBRDate(fim)
  if (!d1 || !d2 || isNaN(d1) || isNaN(d2)) return 0
  if (d2 < d1) return -1
  return Math.floor((d2 - d1) / 86400000) + 1
}

/**
 * Converte ISO (YYYY-MM-DD) para BR (DD/MM/YYYY).
 * Retorna a string original se não for ISO.
 */
export function isoToBR(val) {
  if (!val) return ''
  const m = val.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (m) return `${m[3]}/${m[2]}/${m[1]}`
  return val
}
